export var getShouldShowLogoutModal=function getShouldShowLogoutModal(state){return state.auth.shouldShowLogoutModal;};